import { ListItem } from '../../ListItem';

export class ActionLogStatus {

    private static list: ListItem[] = [
        { "id": 0, "name": "Unactioned" },
        { "id": 1, "name": "Acknowledged" },
        { "id": 2, "name": "Contacted" },
        { "id": 3, "name": "Chatted" }
    ];

    public static List(): ListItem[] {
        return this.list;
    }

    public static Name(id: number): string {
        var idx = this.list.findIndex(i => i.id == id);
        return idx > -1 ? this.list[idx].name : undefined;
    }

    public static Value(name: string): number {
        return this.list.findIndex(i => i.name == name);
    }

}